import axios from 'axios';

import { getAccessToken } from 'src/app/auth/auth';
import { UserService } from 'src/app/auth/user-service';
import { getLocale } from 'src/packages/language/utils';

import { WELL_DIRECTORY_SERVICE_API_URL } from './consts';

const agent = axios.create({
  baseURL: WELL_DIRECTORY_SERVICE_API_URL,
  headers: {
    'content-type': 'application/json',
  },
});

agent.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error?.response?.status === 401) {
      const accessToken = await UserService.updateToken();

      if (error?.config && accessToken) {
        return axios.request({
          ...error.config,
          headers: {
            ...error.config.headers,
            Authorization: `Bearer ${accessToken}`,
          },
        });
      }
    }

    return Promise.reject(error);
  },
);

agent.interceptors.request.use((config) => {
  const accessToken = getAccessToken();

  config.headers['accept-language'] ??= getLocale();

  if (accessToken) {
    config.headers.set('Authorization', `Bearer ${accessToken}`);
  }

  return config;
});

export { agent as wellDirectoryServiceAgent };
